<h3  mat-dialog-title>Claim the task and make it yours</h3>
<div mat-dialog-actions>
   
      <button  mat-button class="example-btn-width" [mat-dialog-close]="data.id"  (click)="claim(data.id)"
      style="cursor:pointer" cdkFocusInitial>
           Claim
      </button>

      <!-- <button mat-raised-button mat-button color="primary" class="example-btn-width" [mat-dialog-close]="data.id"  (click)="claim(data.id)"
      style="cursor:pointer">
           Claim
      </button> -->
    
      <button mat-button  class="example-btn-width" (click)="onNoClick()">Cancel</button>

</div>
